// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"a4d84c05","441":"2d276e3b","484":"5f83f73e","492":"38f5df99","590":"25f76acc","616":"20bde1c7","698":"13676564","831":"3bfd59d8","934":"26fd69ef"}[chunkId] + ".chunk.css";
};